import { useState } from 'react';
import { Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

import pinIcon from '../MapComponents/Icons/Pin.svg'

const center = {
    lat: 38.732995891082204,
    lng: -9.160870313644411,
};

type TProps = {
    getLatLng?: (val: { lat: number, lng: number }) => void;
    draggableMarkerPosition?: { lat: number, lng: number };
}

const StaticMarker = ({ draggableMarkerPosition, getLatLng }: TProps) => {
    const [position, setPosition] = useState(draggableMarkerPosition ? draggableMarkerPosition : center);

    const markerIcon = new L.Icon({
        iconUrl: pinIcon,
        iconSize: [31, 35],
        iconAnchor: [15, 35]
    });

    useMapEvents({
        move: (e) => {
            setPosition(e.target.getCenter());
            //@ts-ignore
            getLatLng(e.target.getCenter());
        }
    })

    return (
        <Marker position={position} icon={markerIcon} />
    );
};

export default StaticMarker;
